/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */

/**
 * Displays a SELECT input. The component supports an array of data as model, or an object whose properties are option
 * groups, and an array of data for each group.
 *
 * <ul>
 * <li>Each data is expected to have an 'id' key and a 'label' key.</li>
 * <li>The 'onChangeFn' is given the selected option.</li>
 * </ul>
 */
export const gmaoSelectComponent = {
    template: require('./gmao-select.html'),
    bindings: {
        model: '=',
        modelOptions: '<',
        options: '<',
        emptyOption: '<',
        labelProperty: '<',
        validationError: '<',
        disabled: '<',
        readonly: '<',
        required: '<',
        placeholderKey: '<',
        hintKey: '<',
        labelNoFloat: '<',
        onChangeFn: '&?'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoSelect.js